import XRegExp from 'xregexp';

export * from './documentation';
export * from './lrs';

/**
 * Current API base URL including version.
 * Not exported for external use. Used only
 * to construct API URLs as constants below.
 */
const API_PREFIX_VERSION_URL = '/api/v2';

/**
 * The front-end application names.
 */
export const APPLICATION_NAMES = {
	FARRAGUT: 'farragut',
	FOGGYBOT: 'foggybot',
	PRINCEGE: 'princege',
};

/**
 * API base URLs including version
 */
export const API_BASE_URL = {

	/**
	 * Waterfro
	 */
	AVATARS: `${API_PREFIX_VERSION_URL}/avatars`,
	COURSES: `${API_PREFIX_VERSION_URL}/courses`,
	DISCOUNTS: `${API_PREFIX_VERSION_URL}/discounts`,
	ENROLLMENTS: `${API_PREFIX_VERSION_URL}/enrollments`,
	ENROLLMENT_TOKENS: `${API_PREFIX_VERSION_URL}/enrollment-tokens`,
	ENROLLMENT_TOKEN_REDEMPTIONS: `${API_PREFIX_VERSION_URL}/enrollment-token-redemptions`,
	GROUPS: `${API_PREFIX_VERSION_URL}/groups`,
	GROUP_MEMBERSHIPS: `${API_PREFIX_VERSION_URL}/group-memberships`,
	INVITATIONS: `${API_PREFIX_VERSION_URL}/invitations`,
	INVOICES: `${API_PREFIX_VERSION_URL}/invoices`,
	INVOICE_ITEMS: `${API_PREFIX_VERSION_URL}/invoice-items`,
	INVOICE_ITEM_REVIEWS: `${API_PREFIX_VERSION_URL}/invoice-item-reviews`,
	MEMBERSHIPS: `${API_PREFIX_VERSION_URL}/memberships`,
	MY_ORGANIZATION: `${API_PREFIX_VERSION_URL}/myorganization`,
	ORGANIZATION_KEYS: `${API_PREFIX_VERSION_URL}/organization-keys`,
	ORGANIZATIONS: `${API_PREFIX_VERSION_URL}/organizations`,
	PAYMENTS: `${API_PREFIX_VERSION_URL}/payments`,
	PAYMENT_SOURCES: `${API_PREFIX_VERSION_URL}/payment-sources`,
	PEOPLE: `${API_PREFIX_VERSION_URL}/people`,
	PRODUCTS: `${API_PREFIX_VERSION_URL}/products`,
	PRODUCT_TICKETS: `${API_PREFIX_VERSION_URL}/product-tickets`,
	PRODUCT_TICKET_GROUPS: `${API_PREFIX_VERSION_URL}/product-ticket-groups`,
	SESSION_ATTENDANCES: `${API_PREFIX_VERSION_URL}/session-attendances`,
	SESSIONS: `${API_PREFIX_VERSION_URL}/sessions`,
	TRACKS: `${API_PREFIX_VERSION_URL}/tracks`,
	USERS: `${API_PREFIX_VERSION_URL}/users`,

	/**
	 * MountVernon
	 */
	ARTICULATES: `${API_PREFIX_VERSION_URL}/articulates`,
	BATCH_MAILCHIMP: `${API_PREFIX_VERSION_URL}/batch/mailchimp`,
	CLONE: `${API_PREFIX_VERSION_URL}/clone`,
	DASHBOARD: `${API_PREFIX_VERSION_URL}/dashboard`,
	DELETION: `${API_PREFIX_VERSION_URL}/deletion`,
	EXPORT: `${API_PREFIX_VERSION_URL}/export`,
	INTEGRATION_META: `${API_PREFIX_VERSION_URL}/integration-meta`,
	INTEGRATIONS: `${API_PREFIX_VERSION_URL}/integrations`,
	METABASE: `${API_PREFIX_VERSION_URL}/metabase`,
	OAUTH: `${API_PREFIX_VERSION_URL}/oauth`,
	REPORTING: `${API_PREFIX_VERSION_URL}/reporting`,
	SERVICES: `${API_PREFIX_VERSION_URL}/services`,
	TRANSLATION: `${API_PREFIX_VERSION_URL}/translation`,
	WEBHOOKS: `${API_PREFIX_VERSION_URL}/webhooks`,
	ZAPIER: `${API_PREFIX_VERSION_URL}/zapier`,

	/**
	 * GalleryP
	 */
	FORM_ENTRIES: `${API_PREFIX_VERSION_URL}/form-entries`,
	FORM_SECTION_ADVANCED_SETTINGS: `${API_PREFIX_VERSION_URL}/form-section-advanced-settings`,
	FORMS: `${API_PREFIX_VERSION_URL}/forms`,
	GEOCODE: `${API_PREFIX_VERSION_URL}/geocode`,

	/**
	 * Columbia
	 */
	EMAIL_LOGS: `${API_PREFIX_VERSION_URL}/email-logs`,
	EMAIL_SENDERS: `${API_PREFIX_VERSION_URL}/email-senders`,
	EMAIL_SERVERS: `${API_PREFIX_VERSION_URL}/email-servers`,
	EMAIL_TRIGGERS: `${API_PREFIX_VERSION_URL}/email-triggers`,
	EMAILS: `${API_PREFIX_VERSION_URL}/emails`,

	/**
	 * Media Library
	 */
	LIVE_STREAMS: `${API_PREFIX_VERSION_URL}/live-streams`,
	MEDIA: `${API_PREFIX_VERSION_URL}/media`,
	VIDEO_PLAYBACK_RESTRICTIONS: `${API_PREFIX_VERSION_URL}/video-playback-restrictions`,
	VIDEOS: `${API_PREFIX_VERSION_URL}/videos`,

	/**
	 * Anacosti
	 */
	EVENT_ACCESS_PERMISSIONS: `${API_PREFIX_VERSION_URL}/event-access-permissions`,
	EVENT_ATTENDANCES: `${API_PREFIX_VERSION_URL}/event-attendances`,
	EVENT_LOCATIONS: `${API_PREFIX_VERSION_URL}/event-locations`,
	EVENT_SPEAKERS: `${API_PREFIX_VERSION_URL}/event-speakers`,
	EVENT_STAGES: `${API_PREFIX_VERSION_URL}/event-stages`,
	EVENT_TOPIC_GROUPS: `${API_PREFIX_VERSION_URL}/event-topic-groups`,
	EVENT_TOPICS: `${API_PREFIX_VERSION_URL}/event-topics`,
	EVENTS: `${API_PREFIX_VERSION_URL}/events`,

	/**
	 * Archives
	 */
	CERTIFICATE_LOGS: `${API_PREFIX_VERSION_URL}/certificate-logs`,
	CERTIFICATE_TEMPLATES: `${API_PREFIX_VERSION_URL}/certificate-templates`,
	CERTIFICATES: `${API_PREFIX_VERSION_URL}/certificates`,
	LINKS: `${API_PREFIX_VERSION_URL}/links`,
	LIVE_NOTIFICATIONS: `${API_PREFIX_VERSION_URL}/live-notifications`,
	MENUS: `${API_PREFIX_VERSION_URL}/menus`,
	MENU_ITEMS: `${API_PREFIX_VERSION_URL}/menu-items`,
	PROGRESS: `${API_PREFIX_VERSION_URL}/progress`,
	RESOURCES: `${API_PREFIX_VERSION_URL}/resources`,
	RULES: `${API_PREFIX_VERSION_URL}/rules`,
	TRACKERS: `${API_PREFIX_VERSION_URL}/trackers`,

	/**
	 * LRS-KOA (CollegeP)
	 */
	LRS: `${API_PREFIX_VERSION_URL}/lrs`,
	NOTIFICATIONS: `${API_PREFIX_VERSION_URL}/notifications`,
	SUBSCRIPTIONS: `${API_PREFIX_VERSION_URL}/subscriptions`,

	/**
	 * NavyYard
	 */
	CHAT: `${API_PREFIX_VERSION_URL}/chat`,
	CHAT_MEMBERS: `${API_PREFIX_VERSION_URL}/chat/members`,

	/**
	 * BranchAv
	 */
	BOARDS: `${API_PREFIX_VERSION_URL}/boards`,
	COMMENTS: `${API_PREFIX_VERSION_URL}/comments`,
	THREADS: `${API_PREFIX_VERSION_URL}/threads`,
	TOPICS: `${API_PREFIX_VERSION_URL}/topics`,

	/**
	 * GeorgiaA
	 */
	POINT_LABELS: `${API_PREFIX_VERSION_URL}/point-labels`,
	POINT_LOGS: `${API_PREFIX_VERSION_URL}/point-logs`,
	POINT_SETTINGS: `${API_PREFIX_VERSION_URL}/point-settings`,
	POINT_TOTALS: `${API_PREFIX_VERSION_URL}/point-totals`,
	POINTS: `${API_PREFIX_VERSION_URL}/points`,

};

export const ENROLLMENT_TYPE = {
	GUEST: 'guest',
	STUDENT: 'student',
	GUEST_EXPERT: 'guest-expert',
	FACILITATOR: 'facilitator',
	CONTENT_EDITOR: 'editor',
	ADMIN: 'administrator',
};

export const MEMBERSHIP_TYPE = {
	ADMIN: 'administrator',
	OWNER: 'owner',
	STUDENT: 'student',
};

export const OAUTH_PROVIDERS = {
	CUSTOM: 'custom',
	GOOGLE: 'google',
	LINKEDIN: 'linkedin',
	MIRO: 'miro',
	ZOOM: 'zoom',
};

export const OAUTH_TYPES = {
	API: 'api',
	SSO: 'sso',
};

export const SCOPES = {
	SESSION: 'session',
	COURSE: 'course',
	TRACK: 'track',
	ORGANIZATION: 'organization',
	GLOBAL: 'global',
};

export const SOCIAL_MEDIA_TYPES = {
	EMAIL: 'email',
	FACEBOOK: 'facebook',
	LINKEDIN: 'linkedin',
	TWITTER: 'twitter',
	MESSAGE: 'message',
};

export const SOCIAL_MEDIA_VALIDATION = {

	// Facebook usernames can only support (A-Z, a-z, 0-9) or a period (".")
	[SOCIAL_MEDIA_TYPES.FACEBOOK]: {
		baseUrl: 'https://www.facebook.com/',
		urlRegex: new RegExp('facebook\.com/([A-Za-z0-9\.]+)/?$'),
		usernameRegex: new RegExp('^[A-Za-z0-9\.]+$')
	},

	// Linkedin usernames only support (A-Z, a-z, 0-9) or a dash ("-")
	[SOCIAL_MEDIA_TYPES.LINKEDIN]: {
		baseUrl: 'https://www.linkedin.com/in/',
		urlRegex: XRegExp.tag()`linkedin.com/in/([\p{L}\p{N}-]+)/?$`,
		usernameRegex: XRegExp.tag()`^[\p{L}\p{N}-]+$`
	},

	// Twitter usernames only support (A-Z, a-z, 0-9) or a underscore ("_")
	// We also support an optional @ sign at the beginning
	[SOCIAL_MEDIA_TYPES.TWITTER]: {
		baseUrl: 'https://www.twitter.com/',
		urlRegex: new RegExp('twitter\.com/(\\w+)/?$'),
		usernameRegex: new RegExp('^@?(\\w+)$')
	},

};

export const TECHCHANGE_DEFAULT_IMAGE_404 =
	'https://d2tnst4joh66uk.cloudfront.net/wp-content/themes/techchange/404/404-Error_06.png';

export const TECHCHANGE_HELP_PAGE_URL =
	'http://docs.techchange.org/';

export const TECHCHANGE_LOGO_ICON =
	'https://d328ser7ogqmui.cloudfront.net/images/tc-logo-icon.png';

export const TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP = '16x9';
export const TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP_V4 = '16by9';

/**
 * Timezone strings.
 */
export const TIMEZONE_UTC = 'UTC';

/**
 * Services
 */
export const VIMEO_VENUES_BASE_URL = 'https://venues.vimeo.com';
export const VIMEO_VENUES_HOSTNAME = 'venues.vimeo.com';
